module.exports = __webpack_public_path__ + "img/hand.5f26bfd2.gif";